import { Component, OnInit } from '@angular/core';
import { BaseClass } from 'src/app/@shared/base-class/base-class';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { MessageService } from 'src/app/@shared/message/message.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';

@Component({
  selector: 'app-bonus-list',
  templateUrl: './bonus-list.component.html',
  styleUrls: ['./bonus-list.component.css']
})
export class BonusListComponent extends BaseClass<any> implements OnInit {

  public data: any;
  public isRedeemLoad: boolean = false;
  public types: any = { 1: 'Deposit', 2: 'Referral', 3: 'Signup' }
  public status: any = { 0: 'In-progress', 1: 'Completed', 2: 'Expired', 3: 'Redeemed', 4: 'Void' }
  public tabs: any[] = [
    { name: 'In-progress', status: [0, 1], data: [] },
    { name: 'Redeemed', status: [3], data: [] },
    { name: 'Expired & Void', status: [2, 4], data: [] },
  ]

  constructor(public service: WebserviceService,
    // public router: Router,
    public _message: MessageService
  ) { super(); }

  ngOnInit(): void {
    this.getData()
  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  getData() {
    this.isLoad = true;
    this.getServices().Get(`${this.env.baseUrl + this.api.bonusList}`).subscribe(
      (res) => {
        this.isLoad = false;
        res?.data?.bonusList.forEach((element: any) => {
          element['text'] = 'Redeem';
          element['wager_target'] = parseFloat(element.wager_target);
          element['wager_completed'] = parseFloat(element.wager_completed);
          element['status'] = this.showRedeemCondition(element) ? 2 : element.status;
        });
        this.data = res?.data?.bonusList;

        this.tabs.forEach(element => {
          element.data = this.data.filter((item: any) => element.status.includes(item.status));
        });
      },
      (err) => {
        console.log(err);
      });
  }

  showRedeemCondition(item: any) {
    // if (item?.status == 0 && parseFloat(item?.wager_target) == parseFloat(item?.wager_completed) && this.checkExpirationDate(item?.expire_date)) {
    if ((item?.status == 0) && this.checkExpirationDate(item?.expire_date)) {
      return true;
    }
    return false;
  }

  checkExpirationDate(expirationDate: any): boolean {
    const currentDate = new Date();
    const expireDate = new Date(expirationDate * 1000);
    return currentDate > expireDate;
  }

  redeemBonusItem(item: any) {
    this.isRedeemLoad = true;
    this.getServices().Get(`${this.env.baseUrl + this.api.bonusRedeem}/${item?.id}`).subscribe(
      (res) => {
        this.isRedeemLoad = false;
        if (res.status == true) {
          this._message.succmessage(res?.data?.message);
          item['text'] = 'Redeem Successfully';
          item['status'] = 3;
        } else {
          this._message.errmessage(res?.data?.message)
        }
      },
      (err) => {
        console.log(err);
      });
  }

  calculatePercentage(e: any) {
    let pr: any = 0;
    pr = (parseFloat(e?.wager_completed) / parseFloat(e?.wager_target)) * 100;
    return this.fixedPostDecimal(pr, 1);
  }

}
